import { Component, OnInit, Input } from '@angular/core';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { EntityActivitiesService } from 'src/app/core/services/entity-activities.service';
import { JobService } from 'src/app/core/services/job.service';
import { RequisitionService } from 'src/app/core/services/requisition.service';

@Component({
  selector: 'app-requisition-activity',
  templateUrl: './requisition-activity.component.html',
  styleUrls: ['./requisition-activity.component.css']
})
export class RequisitionActivityComponent implements OnInit {

  @Input() isSharedRequisition: any;
  @Input() jobId: any;

  loadingFlag: boolean;
  activities: any[];
  currentCompanyName: string;
  infoForActivities: any;
  activityMap: any;
  fullActivityList: any;
  salaryDurationOptions: any = [];
  jobTypeList: any = [];

  isStaffingCompany: boolean = false;

  constructor(
    private authService: AuthService,
    private requisitionService: RequisitionService,
    private activitiesService: EntityActivitiesService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private jobService: JobService
  ) { }

  ngOnInit() {
    //flags
    this.loadingFlag = true;

    //variables
    this.activities = [];
    this.currentCompanyName = "";
    this.currentCompanyName = this.authService.getUserDetails().company.companyName;
    this.isStaffingCompany = this.authService.getUserDetails().company.companyType === 'Staffing';
    this.infoForActivities = {
      isSharedRequisition: this.isSharedRequisition,
      currentCompanyName: this.currentCompanyName
    }
    this.getSalaryDurationOptions();
    this.getAllPreferredJobTypes();
    //get the requisition activity types and then requisition activities
    this.getActivityTypes(() => {
      //     this.getRequisitionActivity();
    });
  }

  getRequisitionActivity() {
    this.requisitionService.getRequisitionActivity(this.jobId, 1, 250, (data) => {
      let info = { isSharedRequisition: this.isSharedRequisition, currentCompanyName: this.currentCompanyName };
      this.activities = this.activitiesService.getMassagedActivities(data, this.activityMap, "requisition", info, this.isStaffingCompany, this.jobTypeList, this.salaryDurationOptions);
      angular.forEach(this.activities, (activity, index) => {
        if (activity.activityType == 'addCandidate' || activity.activityType == 'associateCandidate' || activity.activityType == 'pullCandidate' || (!_.isNull(activity.candidateNameList) && activity.candidateNameList.length > 0)) {
          // this.setSmallText(index);
        }
      });
      this.loadingFlag = false;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  expandText($event, activity) {
    if (activity.showShortMessageFlag) {
      activity.showShortMessageFlag = false;
    } else {
      activity.showShortMessageFlag = true;
    }
    $event.stopPropagation();
  }

  getActivityTypes(successCallback) {
    this.jobService.getActivityTypes((data) => {
      this.fullActivityList = data;
      this.activityMap = [];
      angular.forEach(data, (val, key) => {
        this.activityMap[val.value] = val.name;
      });
      successCallback();
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getSalaryDurationOptions() {
    this.jobService.getSalaryDurationOptions((data) => {
      this.salaryDurationOptions = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes() {
    this.jobService.getAllJobTypes((data) => {
      this.jobTypeList = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

}
